import endpoints from "../config/endpoints";
import api from "../config/axios";

export const getAllProducts = async (params = {}) => {
    try {
        // Check if user is logged in and add userIdForDiscount if so
        const userId = localStorage.getItem("userId");
        const latitude = localStorage.getItem("latitude");
        const longitude = localStorage.getItem("longitude");

        if (longitude == null && latitude == null) {
            return {
                products: [],
                status: false,
                statusCode: 500,
                message: "Please Select Location!",
            };
        }

        if (latitude)
            params.latitude = latitude;
        if (longitude)
            params.longitude = longitude;
        if (userId) {
            params.userIdForDiscount = userId;
        }

        // Handle array parameters properly for URLSearchParams
        const searchParams = new URLSearchParams();

        Object.keys(params).forEach(key => {
            if (key === 'signal') {
                // Skip signal as it's not a query parameter
                return;
            }

            const value = params[key];
            if (Array.isArray(value)) {
                // For arrays, append each value separately
                value.forEach(item => {
                    searchParams.append(key, item);
                });
            } else {
                searchParams.append(key, value);
            }
        });

        const query = searchParams.toString();
        const url = `${endpoints.products.getAll}?${query}`;

        const response = await api.get(url, { signal: params.signal });

        // Return the full response with pagination metadata
        return {
            products: response.data.data || [],
            pagination: {
                pageIndex: response.data.pageIndex,
                pageSize: response.data.pageSize,
                totalRecord: response.data.totalRecord,
            },
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    }
    catch (error) {
        const errRes = error.response?.data;

        return {
            products: [],
            status: errRes?.status ?? false,
            statusCode: errRes?.statusCode ?? 500,
            message: errRes?.message ?? "Something went wrong",
        };
    }
};

export const AddReviewOnProduct = async (reviewData) => {
    try {
        const response = await api.post(endpoints.ProductReview.AddReviewOnProduct, reviewData);

        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error adding review on product:', error);
        throw error;
    }
};

// Alias for backward compatibility
export const getProducts = getAllProducts;

const productService = {
    getProducts,
    AddReviewOnProduct
};

export default productService;
